<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-26 14:38:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-30 18:00:10
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/components/FoodAddOrEdit/index.vue
-->
<template>
  <div class="foodadd-edit">
    <el-scrollbar
      ref="scrollbar"
      style="height: 100%"
      wrap-style="overflow-x:hidden;"
    >
      <section class="section-food">
        <div class="header">
          <p></p>
          <h1>{{ isFoodType ? "新增" : "修改" }}菜肴</h1>
        </div>
        <el-form
          size="small"
          label-width="100px"
          label-position="left"
          :rules="addFoodrules"
          :model="fromParamData"
          ref="addRuleForm"
        >
          <el-form-item label="菜肴名称:" prop="name">
            <el-input
              v-model="fromParamData.name"
              maxlength="15"
              placeholder="请输入菜肴名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="菜肴简称:" prop="abbreviation">
            <el-input
              v-model="fromParamData.abbreviation"
              maxlength="15"
              placeholder="请输入菜肴简称"
            ></el-input>
          </el-form-item>

          <div>
            <el-form-item label="菜肴大类:" prop="delicaciesBigId">
              <el-select
                v-model="fromParamData.delicaciesBigId"
                @change="selectFoodMaxClassChange"
                ref="selectFoodBigRef"
                placeholder="请选择菜肴大类"
              >
                <el-option
                  v-for="item in foodTreeData"
                  :key="item.index"
                  :label="item.categoryName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="菜肴小类:" prop="delicaciesSmallId">
              <el-select
                ref="selectFoodSmallRef"
                v-model="fromParamData.delicaciesSmallId"
                placeholder="请选择菜肴小类"
              >
                <el-option
                  v-for="item in foodSmallList"
                  :key="item.index"
                  :label="item.categoryName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否启用:" prop="status">
              <el-radio-group v-model="fromParamData.status">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="搜索食物:">
              <el-select
                filterable
                remote
                :remote-method="querySearchAsync"
                :loading="loading"
                v-model="foodName"
                placeholder="请输入你要找的食物"
                @change="handleSelect"
                @remove-tag="removetag"
                class="serchInput"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <el-option
                  v-for="(item, index) in selectFoodList"
                  :key="index"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <div class="tabelBox">
              <el-table
                :data="fromParamData.delicaciesFoodVOS"
                class="tabelBox"
                width="440"
                :header-cell-style="{
                  background: '#FAFAFA',
                  color: '#333333',
                  height: '37px',
                }"
                tooltip-effect="dark"
                ref="multipleTable"
                fit
                highlight-current-row
              >
                <el-table-column align="center" label="食物名称">
                  <template slot-scope="scope">
                    {{ scope.row.foodName }}
                  </template>
                </el-table-column>
                <el-table-column align="center" label="重量">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      class="weightBox"
                      onkeyup="this.value=this.value.match(/\d+\.?\d{0,1}/)"
                      onafterpaste="this.value=this.value.match(/\d+\.?\d{0,1}/)"
                      @change="calculatetheEnergy"
                      max="10000"
                      min="1"
                      v-model="scope.row.count"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      class="delete"
                      @click="deleteColumn(scope.$index, scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form>
      </section>

      <section class="section-maintain" style="margin-top: 20px">
        <div class="header">
          <p></p>
          <h1>菜肴营养素</h1>
        </div>
        <div class="nutrition">
          <div class="nutritionItem">
            <span class="label">能量</span>
            <span class="vals">{{ fromParamData.energyKcal }}kcal</span>
          </div>
          <div class="nutritionItem">
            <span class="label">能量</span>
            <span class="vals">{{ fromParamData.energyKj }}kJ</span>
          </div>
        </div>
        <div class="nutrition">
          <div class="nutritionItem">
            <span class="label">蛋白质</span>
            <span class="vals">{{ fromParamData.protein }}g</span>
          </div>
          <div class="nutritionItem">
            <span class="label">碳水化合物</span>
            <span class="vals">{{ fromParamData.carbohydrate }}g</span>
          </div>
        </div>
        <div class="nutrition">
          <div class="nutritionItem">
            <span class="label">脂肪</span>
            <span class="vals">{{ fromParamData.axunge }}g</span>
          </div>
          <div class="nutritionItem"></div>
        </div>
        <div class="submit-btn">
          <el-button @click="replacementHandel">重置</el-button>
          <el-button type="primary" @click="submitHandel">保存</el-button>
        </div>
      </section>
    </el-scrollbar>
  </div>
</template>
<script>
import fromList from "../../common/form.config";
import { apiPostAddFood } from "../../api";
import { apiPostFoodList } from "../../api";
import eventBus from "@/utils/eventBus";

export default {
  name: "FoodAddOrEdit",
  mixins: [fromList],
  props: {
    //食物分类
    foodTreeData: {
      type: Array,
      default: () => [],
    },
    //是新增还是修改
    isFoodType: {
      type: Boolean,
      default: true,
    },
    //数据回显
    showParamsData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showViewFlag: true, //解决重置或者清空后验证规则还存在的bug
      foodBigList: [], //食物大类列表
      foodSmallList: [], //食物小类列表
      sarchResult: [],
      foodName: "",
      foodList: [], //搜索总的
      selectFoodList: [],
      loading: false,
      seracResult: [],
      //需要提交的参数
      fromParamData: {
        id: "",
        abbreviation: "", //食品简称
        name: "", //食品名称
        delicaciesBigId: "", //食品大类id
        delicaciesSmallId: "", //食品小类id
        status: 0, //	0启用 1停用
        delicaciesFoodVOS: [],
        axunge: "0", //脂肪
        carbohydrate: "0", //碳水化合物g
        energyKcal: "0", //能量kcal
        energyKj: "0", //能量kJ
        protein: "0", //蛋白质g
      },
    };
  },
  watch: {
    showParamsData: {
      handler(newVal, oldVal) {
        // this.echoHandel(newVal);
         this.fromParamData=newVal
      },
      deep: true,
    },
  },
  mounted() {
    this.handleScroll();
  },
  methods: {
    /**
     * @description: 搜索食物
     * @param {*}
     * @return {*}
     */
    querySearchAsync(query) {
      if (query !== "") {
        this.loading = true;
        apiPostFoodList({ redundant: query }).then((res) => {
          this.loading = false;
          let foodList = res.data;
          this.selectFoodList = foodList;
        }).catch(e => {
          this.loading = false
        })
      } else {
        this.selectFoodList = [];
      }
    },
    handleSelect() {
      this.sarchResult.push(this.foodName);
      this.foodName = "";
      this.selectFoodList = [];
      this.fromParamData.delicaciesFoodVOS = this.sarchResult.map((item) => {
        let json = {};
        json.count = "";
        json.foodId = item.id;
        json.foodName = item.name;
        json.energyKcal = item.energyKcal ? item.energyKcal : 0;
        json.energyKj = item.energyKj ? item.energyKj : 0;
        json.protein = item.protein ? item.protein : 0;
        json.fat = item.fat ? item.fat : 0;
        json.carbohydrate = item.carbohydrate ? item.carbohydrate : 0;
        json.ediblePart = item.ediblePart ? item.ediblePart : 0;
        return json;
      });
      this.calculatetheEnergy();
    },
    FilterData(a, b) {
      //循环判断数组a里的元素在b里面有没有，有的话就放入新建立的数组中
      var result = new Array();
      var c = b.toString();
      for (var i = 0; i < a.length; i++) {
        if (c.indexOf(a[i].id.toString()) > -1) {
          result.push(a[i]);
        }
      }
      return result;
    },
    //删除食物列表
    deleteColumn(index, row) {
      this.fromParamData.delicaciesFoodVOS.splice(index, 1);
      if (this.fromParamData.delicaciesFoodVOS.length == 0) {
        this.sarchResult = [];
        this.fromParamData.energyKcal = 0;
        this.fromParamData.energyKj = 0;
        this.fromParamData.protein = 0;
        this.fromParamData.carbohydrate = 0;
        this.fromParamData.axunge = 0;
        return;
      }
      this.calculatetheEnergy();
    },
    removetag() {
      this.calculatetheEnergy();
    },
    //计算能量
    calculatetheEnergy() {
      if (this.fromParamData.delicaciesFoodVOS.length == 0) {
        this.fromParamData.energyKcal = 0;
        this.fromParamData.energyKj = 0;
        this.fromParamData.protein = 0;
        this.fromParamData.carbohydrate = 0;
        this.fromParamData.axunge = 0;
        return;
      }
      let energyKcalArr = [];
      let energyKjArr = [];
      let proteinArr = [];
      let carbohydrateArr = [];
      let axungeArr = [];
      this.fromParamData.delicaciesFoodVOS.forEach((item) => {
        let energyKcal = (
          ((((item.count ? item.count : 0) / 100) * item.ediblePart) / 100) *
          item.energyKcal
        ).toFixed(1);
        let energyKj = (
          ((((item.count ? item.count : 0) / 100) * item.ediblePart) / 100) *
          item.energyKj
        ).toFixed(1);
        let protein = (
          ((((item.count ? item.count : 0) / 100) * item.ediblePart) / 100) *
          item.protein
        ).toFixed(1);
        let carbohydrate = (
          ((((item.count ? item.count : 0) / 100) * item.ediblePart) / 100) *
          item.carbohydrate
        ).toFixed(1);
        let axunge = (
          ((((item.count ? item.count : 0) / 100) * item.ediblePart) / 100) *
          item.fat
        ).toFixed(1);
        energyKcalArr.push(energyKcal);
        energyKjArr.push(energyKj);
        proteinArr.push(protein);
        carbohydrateArr.push(carbohydrate);
        axungeArr.push(axunge);
      });
      this.fromParamData.energyKcal = this.sum(energyKcalArr);
      this.fromParamData.energyKj = this.sum(energyKjArr);
      this.fromParamData.protein = this.sum(proteinArr);
      this.fromParamData.carbohydrate = this.sum(carbohydrateArr);
      this.fromParamData.axunge = this.sum(axungeArr);
      //if(){}
    },
    sum(arr) {
      return arr.reduce(function (prev, curr, idx, arr) {
        return Number(prev) + Number(curr);
      });
    },
    /**
     * @description: 新增食物和修改食物
     * @param {*}
     * @return {*}
     */
    submitSuccessHandel(optios) {
      apiPostAddFood(optios).then((res) => {
        if (res.code == 0) {
          this.$refs["addRuleForm"].resetFields();
          this.fromParamData = this.$options.data().fromParamData;
          this.fromParamData.delicaciesFoodVOS = [];
          this.foodName = [];
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$emit("submitSuccess");
          this.scrollHandel();
        }
      });
    },
    /**
     * @description: 重置功能
     * @param {*}
     * @return {*}
     */
    replacementHandel() {
      this.$refs["addRuleForm"].resetFields();
      this.fromParamData.delicaciesFoodVOS = [];
      this.foodName = [];
      this.fromParamData = this.$options.data().fromParamData;
      this.updateFoodType();
      this.scrollHandel();
    },

    /**
     * @description: 数据回显
     * @param {*}
     * @return {*}
     */
    echoHandel(value) {
      Object.keys(this.fromParamData).forEach((item) => {
        this.fromParamData[item] = value[item];
      });
      if (this.fromParamData.delicaciesBigId) {
        this.foodSmallList = this.foodTreeData.filter(
          (item) => item.id == value.delicaciesBigId
        )[0].children;
      }
    },

    /**
     * @description: 更新父组件传递过来的参数
     * @param {*}
     * @return {*}
     */
    updateFoodType() {
      this.showViewFlag = false;

      if (!this.isFoodType) this.$emit("update:isFoodType", !this.isFoodType);
      this.fromParamData = this.$options.data().fromParamData;
      setTimeout(() => {
        this.showViewFlag = true;
      }, 10);
      this.scrollHandel();
    },
    /**
     * @description: 初始化滚动条
     * @param {*}
     * @return {*}
     */
    scrollHandel() {
      this.$refs.scrollbar.wrap.scrollTop = 0; //想滚到哪个高度，就写多少
    },

    /**
     * @description: 监听滚动事件，当滚动距离大于 关闭select选择框
     * @param {*}
     * @return {*}
     */
    handleScroll() {
      let scrollbarEl = this.$refs.scrollbar.wrap;
      scrollbarEl.onscroll = () => {
        if (scrollbarEl.scrollTop > 178) this.$refs.selectFoodBigRef.blur();
        if (scrollbarEl.scrollTop > 230) this.$refs.selectFoodSmallRef.blur();
      };
    },

    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    inputChage(item, e) {
      // var reg = /[1-9][0-9]*/g;
      item.value = item.value.replace(/[^\d^\.]+/g, "");
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    submitHandel() {
      this.$refs["addRuleForm"].validate((valid) => {
        if (valid) {
          this.submitSuccessHandel(this.fromParamData);
        } else {
        }
      });
    },
    /**
     * @description: 选择大类得到小类下面的children为小类
     * @param {*}
     * @return {*}
     */
    selectFoodMaxClassChange(e) {
      this.fromParamData.delicaciesSmallId = "";
      this.foodSmallList = this.foodTreeData.filter(
        (item) => item.id == e
      )[0].children;
    },
  },
};
</script>

<style scoped lang="less">
.tabelBox {
  width: 440px;
  margin-left: 10px;
}
.serchInput {
  /deep/ .el-select__input {
    padding-left: 15px;
  }
}
/deep/.weightBox {
  width: 120px !important;
  height: 30px;
  border-radius: 2px;
  .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 30px !important;
    line-height: 30px !important;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }
}
.nutrition {
  width: 440px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  margin-left: 30px;
  margin-bottom: 30px;
  .nutritionItem {
    flex: 1;
    display: flex;
    align-items: center;
    span {
      display: block;
      width: 100px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
.delete {
  font-size: 12px !important;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1a7bfc !important;
}
/deep/ .el-table td,
.el-table th {
  padding: 0 !important;
  height: 40px !important;
}
.foodadd-edit {
  padding: 16px;
  height: calc(100vh - 254px);

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    p {
      width: 4px;
      height: 15px;
      background: #1a7bfc;
      margin-right: 12px;
    }
    h1 {
      font-size: 14px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
    }
  }
  .section-food {
    .el-input,
    .el-select {
      width: 360px;
    }
    /deep/.el-form-item__label {
      text-align: center;
      font-weight: 400;
      color: #333333;
      font-size: 12px;
    }
  }
  .section-maintain {
    /deep/.el-form-item__label {
      text-align: center;
      font-weight: 400;
      color: #333333;
      font-size: 12px;
    }
    .el-form-item {
      width: 50%;
      margin-right: 0;
      .el-input {
        width: 135px;
      }
    }
    .submit-btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/.el-form-item__label {
        text-align: center;
        font-weight: 400;
        color: #333333;
        font-size: 12px;
      }
      & /deep/ .el-button--default {
        width: 110px;
        height: 32px;
        line-height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &/deep/ .el-button--primary {
        background-color: #1a7bfc;
        width: 110px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &/deep/ .el-button:focus,
      .el-button:hover {
        border-color: #1a7bfc;
      }
    }
  }
}
</style>